import { render, staticRenderFns } from "./SnNewRanking.vue?vue&type=template&id=cab4d818&scoped=true"
import script from "./SnNewRanking.vue?vue&type=script&lang=js"
export * from "./SnNewRanking.vue?vue&type=script&lang=js"
import style0 from "./SnNewRanking.vue?vue&type=style&index=0&id=cab4d818&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cab4d818",
  null
  
)

export default component.exports